export default __webpack_public_path__ + "static/media/invoice-green.9d9293f6.svg";